<div class="o-modal--alert o-modal--success o-modal--medium" id="mod-ap-req" style="width: 100%;">
    <div class="o-modal__head">
        <span class="o-modal__close close-modal" matDialogClose></span>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalRecordsTerminatePortal.title' | translate}}</label>
    </div>
    <div class="o-modal__body" style="padding-left: 40px;">
        <p>{{ 'ModalRecordsTerminatePortal.body' | translate}}</p>
        <textarea input class="o-form__textarea" placeholder="{{ 'ModalRecordsTerminatePortal.terminateLabel' | translate}}" [(ngModel)]="observation"></textarea>
    </div>

    <div class="o-modal__footer">
        <div>
            <span  mat-dialog-close class="btn btn--default" style="padding-left: 19px;"><u>{{ 'ModalRecordsTerminatePortal.btnCancel' | translate }}</u></span>
            <button *ngIf="observation!==''" mat-button class="btn btn--primary" (click)="aceptar()">{{ 'ModalRecordsTerminatePortal.btnTerminate'| translate }}</button>
        </div>
    </div>
</div>


<ngx-spinner name="modalaccessTerminate" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat">
    <p style="font-size: 20px; color: white">{{'ModalRecordsTerminatePortal.spinner'|translate}}...</p>
</ngx-spinner>